import React, { useEffect, useState } from 'react'
import ImageRender from './ImageRender'
import VideoRender from './VideoRender'

const MediaRender = ({ file, options={}, alt='', orientation }) => {
    const [media, setMedia] = useState(null)

    useEffect(() => {
        let output = null

        if (file && file.media_type) {
            switch (file.media_type) {
            case 'video':
            case 'video/youtube':
            case 'video/vimeo':
                if ( options && (!options.coverImage) && file.media_type === 'video/youtube' && !options.autoplay ) {
                    options.coverImage = {
                        filepath: `https://img.youtube.com/vi/${file.filename}/maxresdefault.jpg`,
                        type: 'static',
                        media_type: 'image',
                    }
                }
                output = (<VideoRender file={file} options={options} />)
                break
            default:
                output = (<ImageRender file={file} options={options} orientation={orientation} alt={alt} />)
                break
            }
            setMedia(output)
        }
    }, [file])

    return media
}

export default MediaRender
